import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const exportConsentLogs = createAsyncThunk(
  "consentLogs/export",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.get("/export-consents", {
        params: queryParams,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "consent-logs.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();

      return true;
    } catch (error) {
      return rejectWithValue("Export failed");
    }
  },
);